import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    page: pageModel
}

const currencySlice = createSlice({
    name: 'currency',
    initialState,
    reducers: {
        setCurrencyPageAction: (state, action) => {
            state.page = action.payload
        },
        getCurrencyPageAction: (state, action) => {
            const content = state.page.content.concat(action.payload.content)
            state.page = { ...action.payload, content }
        },
        addCurrencyAction: (state, action) => {
            state.page.content.unshift(action.payload)
        },
        updateCurrencyAction: (state, action) => {
            const content = state.page.content.map((c) => {
                if (c.id === action.payload.id) return action.payload
                else return c
            })
            state.page.content = content
        },
        deleteCurrencyAction: (state, action) => {
            const content = state.page.content.filter(p => p.id !== action.payload)
            state.page.content = content
        }
    },
});

export const { setCurrencyPageAction, getCurrencyPageAction, addCurrencyAction, updateCurrencyAction, deleteCurrencyAction } = currencySlice.actions;
export default currencySlice;